<app-device-features-container
  actionButtonName="{{
    '+INSTALLATIONS.INSTALLATION.FEATURE_CONTAINER.DETAILS_BUTTON' | translate
  }}"
  [header]="'+INSTALLATIONS.INSTALLATION.BATTERY.TITLE' | translate"
  [overlayType]="availableOverlays.Battery"
  [deviceSelectId]="deviceSelectId"
>
  <!-- ess.operationState -->
  <ng-container feature *ngIf="basicState || exceptionsState; else batteryOperationState">
    <app-feature-tile
      feature
      [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.STATE' | translate"
      [value]="basicState"
      [preLabel]="exceptionsState"
      isFullWidth="true"
      [preLabelStyles]="preLabelStyles"
    ></app-feature-tile>
  </ng-container>

  <ng-template #batteryOperationState>
    <app-feature-tile
      data-at-battery-state
      *ngIf="batteryOperationState$ | async | ready as feature"
      feature
      [error]="feature | error"
      [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.STATE' | translate"
      [value]="feature | value2: featurePropertyKey.value | translateEssOperatingState"
      [attr.data-feature]="feature.feature"
      isFullWidth="true"
    ></app-feature-tile>
  </ng-template>

  <!-- ess.power.consolidated for cascade device -->
  <app-feature-tile
    *ngIf="
      (powerConsolidatedFeatures$ | async | ready) &&
        (powerConsolidatedPerDevice$ | async) as feature;
      else powerConsolidated
    "
    feature
    data-at-battery-power
    [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.POWER' | translate"
    value="{{ feature | featureLike | value2: featurePropertyKey.value }} {{
      feature | featureLike | unit: featurePropertyKey.value
    }}"
  >
  </app-feature-tile>

  <!-- ess.power for single device -->
  <ng-template #powerConsolidated>
    <app-feature-tile
      *ngIf="power$ | async | ready as feature"
      feature
      data-at-battery-power
      [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.POWER' | translate"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
    ></app-feature-tile>
  </ng-template>

  <!-- ess.stateOfCharge.consolidated for cascade device -->
  <app-feature-tile
    data-at-battery-charge
    *ngIf="
      (devicesStore.shouldUseConsolidatedFeature$ | async) &&
        (stateOfChargeConsolidatedFeatures$ | async | ready) &&
        (stateOfChargeConsolidatedPerDevice$ | async) as feature;
      else stateOfCharge
    "
    feature
    [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.STATE_OF_CHARGE' | translate"
    value="{{ feature | featureLike | value2: featurePropertyKey.value }} {{
      feature | featureLike | unit: featurePropertyKey.value
    }}"
  >
  </app-feature-tile>

  <!-- ess.stateOfCharge for single device -->
  <ng-template #stateOfCharge>
    <app-feature-tile
      data-at-battery-charge
      *ngIf="stateOfCharge$ | async | ready as feature"
      feature
      [error]="feature | error"
      [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.BATTERY.STATE_OF_CHARGE' | translate"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-tile>
  </ng-template>
</app-device-features-container>
